import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useEquipmentModelSensors } from '../../hooks/useEquipment';

/** ATEK sensors on this model: confirmed links, plus sensors whose manufacturer/model match an alias. */
export function EquipmentSensorsTab({ modelId }: { modelId: string }) {
  const { data: sensors = [], isLoading } = useEquipmentModelSensors(modelId);

  if (isLoading) {
    return <div className="flex justify-center py-8"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>;
  }
  if (!sensors.length) return <p className="text-sm text-muted-foreground">No ATEK sensors are on this model yet.</p>;

  return (
    <div className="rounded-lg border bg-card overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-muted text-xs text-muted-foreground">
          <tr>
            <th className="px-3 py-2 text-left font-medium">Sensor</th>
            <th className="px-3 py-2 text-left font-medium">Account · site</th>
            <th className="px-3 py-2 text-left font-medium">Link</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {sensors.map((sensor) => (
            <tr key={sensor.mongoSensorId}>
              <td className="px-3 py-2">{sensor.name ?? sensor.mongoSensorId}</td>
              <td className="px-3 py-2 text-muted-foreground">{[sensor.accountName, sensor.siteName].filter(Boolean).join(' · ') || '—'}</td>
              <td className="px-3 py-2">
                <span className={cn('inline-flex rounded-full border px-2 py-0.5 text-xs',
                  sensor.linked ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-muted text-muted-foreground')}
                  title={sensor.linked ? 'Confirmed on site or in review' : 'Matched from the sensor manufacturer/model fields'}>
                  {sensor.linked ? 'Linked' : 'Matched'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
